
const getCookieValue = (name) =>
			document.cookie
				.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')
				?.pop() || '';

export function openClose() {
  const $hamburger = document.getElementById('hamburger');
  const $navBar = document.getElementById('nav__bar');
  const $navMenu = document.getElementById('nav__menu');
  const $mainContainer = document.getElementById('main-container');

  $hamburger.classList.toggle('is-active'); // the class is used by hamburgers
  $mainContainer.classList.toggle('main-container--active');

  const isOpen = $navMenu.classList.contains('nav__menu--slide-in');
  if (isOpen) {
    $navBar.classList.remove('nav__bar--fade-in');
    $navMenu.setAttribute('class', 'nav__menu nav__menu--slide-out');
    $hamburger.setAttribute('aria-expanded', 'false');
    return;
  }
  $hamburger.setAttribute('aria-expanded', 'true');
  $navBar.classList.add('nav__bar--fade-in');
  $navMenu.setAttribute('class', 'nav__menu nav__menu--slide-in');
}

export default function siteHeaderJs(options = {}) {
  try {
    const $hamburger = document.getElementById('hamburger');
    const $navBar = document.getElementById('nav__bar');
    const $navMenu = document.getElementById('nav__menu');

    function isPageScrolled() {
      return window.scrollY > $navBar.parentNode.parentNode.clientHeight;
    }

    // click on first level navigation (mobile)
    const $navSubtitle = document.querySelectorAll('.nav__subtitle');
    $navSubtitle.forEach((subtitle) => {
      subtitle.addEventListener('click', (e) => {
        const $button = e.target;
        const expanded = $button.getAttribute('aria-expanded') === 'true';

        // Toggle aria-expanded
        $button.setAttribute('aria-expanded', String(!expanded));

        // Toggle the menu
        const $ul = $button.nextElementSibling;
        if ($ul) {
          $ul.classList.toggle('nav__submenu--active');
        }
      });
    });

    // click back from second level to first level nav
    const $navBack = document.querySelectorAll('.nav__back > button');
    $navBack.forEach((backButton) => {
      backButton.addEventListener('click', (e) => {
        const $ul = e.target.parentNode.parentNode;

        // Set all nav__subtitle in the current nav level to aria-expanded="false"
        const $allNavSubtitles = $ul.parentNode.querySelectorAll('.nav__subtitle[aria-expanded="true"]');
        $allNavSubtitles.forEach(btn => btn.setAttribute('aria-expanded', 'false'));

        setTimeout(() => {
          // it removes all the classes after the animation has ended
          $ul.classList.remove('nav__submenu--active');
          $ul.classList.remove('nav__submenu--inactive');
        }, 500);
        $ul.classList.add('nav__submenu--inactive'); // slide-out
      });
    });

    // this section checks if the special menu has more than 4 items.
    // if so, then removes some copy contained in .nav__special-content
    // used in jameson hosts but it works everywhere now.
    const $navSpecialWrappers= document.querySelectorAll('.nav__special-wrapper');
    $navSpecialWrappers.forEach((element) => {
      const $specialLinks = element.querySelector('.nav__special-links');
      if ($specialLinks.children.length >= 4) {
        const $specialContent = element.querySelectorAll('.nav__special-content');
        $specialContent.forEach((elementSpecialContent) => {
          elementSpecialContent.style.display = 'none';
        });
      }
    });

    // close menu when clicked on a link (mobile)
    if (
      window.outerWidth <=
      getComputedStyle(document.documentElement).getPropertyValue('--portrait')
    ) {
      // open close menu
      if ($hamburger !== null) {
        $hamburger.addEventListener('click', () => {
          openClose();
        });
      }

      // closes menu when click on any link
      const $navLinks = $navMenu.querySelectorAll('a');
      $navLinks.forEach((aLink) => {
        aLink.addEventListener('click', () => {
          openClose();
        });
      });
    }

    if (
      window.outerWidth >
      getComputedStyle(document.documentElement).getPropertyValue('--portrait')
    ) {
      // it manages hover/mouseenter on first level navigation item (desktop)
      // it triggers the modal
      const $navDropdown = document.querySelectorAll('.nav__dropdown');
      const $modalMenu = document.querySelectorAll('.modal-menu')[0];
      $navDropdown.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          const toggle = item.querySelector('.nav__subtitle');

          $modalMenu.classList.add('modal-menu--active');
          $navBar.classList.add('nav__bar--fade-in-scroll');

          // Find the toggle button (.nav__subtitle) in this dropdown and set aria-expanded="true".
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
        item.addEventListener('mouseleave', () => {
          $modalMenu.classList.remove('modal-menu--active');
          const toggle = item.querySelector('.nav__subtitle');

          if (!isPageScrolled()) {
            $navBar.classList.remove('nav__bar--fade-in-scroll');
          }

          // Set aria-expanded="false" on the toggle button.
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
          }

        });
      });

      // WCAG, keyboard navigation
      const $ariaPopups = $navMenu.querySelectorAll('button[aria-haspopup]');
      $ariaPopups.forEach((ariaPopup) => {
        const $ulnav = ariaPopup.nextElementSibling; // all the UL nav_l1 submenu
        ariaPopup.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const expanded = ariaPopup.getAttribute('aria-expanded') === 'true';
            ariaPopup.setAttribute('aria-expanded', !expanded);
            $ulnav.hidden = expanded;
            $ulnav.style.visibility = expanded ? 'hidden' : 'visible';
            $ulnav.style.opacity = expanded ? '0' : '1';
          }
        });

        // $ulnav.addEventListener('mouseleave', () => {
        //   ariaPopup.setAttribute('aria-expanded', 'false');
        //   $ulnav.hidden = true;
        //   $ulnav.style.visibility = 'hidden';
        //   $ulnav.style.opacity = '0';
        // });
      });

      // get Max Height of first level navigation title
      const getMaxHeight = ($dropdown) => {
        let maxHeight = 0;
        const $spans = $dropdown.querySelectorAll('.nav__l1 li > span');
        if ($spans.length > 0) {
          $spans.forEach(($span) => {
            if ($span.offsetHeight > maxHeight) {
              maxHeight = $span.offsetHeight;
            }
          });
        }
        return maxHeight;
      };

      // set minHeight of first level navigation title
      const setMaxHeight = ($dropdown, mixHeight = 'auto') => {
        const $spans = $dropdown.querySelectorAll('.nav__l1 li > span');
        if ($spans.length > 0) {
          $spans.forEach(($span) => {
            $span.style.minHeight = `${mixHeight}px`;
          });
        }
      };

      // get dropdown elements from the menu and set minHeight of the first level title
      const menuTitleItems = document.querySelectorAll(
        '.nav__top-menu .nav__dropdown'
      );
      if (menuTitleItems.length > 0) {
        menuTitleItems.forEach(($li) => {
          setMaxHeight($li, getMaxHeight($li));
        });
      }
    }

    // it changes opacity when the page is scrolled
    window.addEventListener('scroll', () => {
      if (isPageScrolled()) {
        $navBar.classList.add('nav__bar--fade-in-scroll');
      } else {
        $navBar.classList.remove('nav__bar--fade-in-scroll');
      }
    });

  } catch (error) {
    console.error(error);
  }
}
